import { UserActionTypes } from './user.types';

const initialState: WebOrder.State.User = {
  hCaptchaTokens: {
    requestPhoneLoginCodeSmsToken: '',
  },
};

export const userReducer = (
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: WebOrder.State.User = initialState,
  action: UserActionTypes,
): WebOrder.State.User => {
  switch (action.type) {
    case 'SET_HCAPTCHA_TOKEN': {
      return {
        ...state,
        hCaptchaTokens: {
          ...state.hCaptchaTokens,
          ...action.payload,
        },
      };
    }

    default:
      return state;
  }
};
